"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CompanyInformation() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="unternehmensinformationen" className="py-[120px] !text-[hsl(43,96%,56%)] !bg-[hsl(46,97%,65%)]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
        <div className="grid grid-cols-1 gap-12 !text-[hsl(38,92%,50%)] !bg-[hsl(45,93%,47%)] md:grid-cols-12 md:gap-16 lg:gap-24">
          
          {}
          

          {}
          <div ref={rightRef} className={`md:col-span-8 font-mono text-sm sm:text-base leading-relaxed text-foreground transition-all duration-700 delay-200 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 sm:gap-12">
              
              {}
              <div className="space-y-2">
                <p className="font-bold text-foreground mb-4 tracking-tight !text-lg">Hauptsitz</p>
                <p className="!text-base">T&M Hoch & Tiefbau</p>
                <p className="!text-base">Gymnasialstraße 2</p>
                <p className="!text-base">55543 Bad Kreuznach</p>
                <p className="!text-base">Deutschland</p>
              </div>

              {}
              <div className="space-y-2">
                <p className="font-bold text-foreground mb-4 tracking-tight">Kontakt</p>
                <div className="flex gap-3">
                  <span className="text-muted-foreground w-6 shrink-0 !text-base">T:</span>
                  <Link to="tel:+49891234567" className="transition-colors duration-200 !text-base hover:text-primary">+49 (0) 1791505044</Link>
                </div>
                
                <div className="flex gap-3">
                  <span className="text-muted-foreground w-6 shrink-0">E:</span>
                  <Link to="mailto:kontakt@technova.de" className="transition-colors duration-200 !text-base hover:text-primary">Info-TMBau@web.de</Link>
                </div>
              </div>
            </div>

            {}
            <div className="mt-16 pt-8 border-t border-border/60 grid grid-cols-1 sm:grid-cols-2 gap-8 text-xs sm:text-sm text-muted-foreground">
              <div className="space-y-2">
                <p className="flex flex-col sm:flex-row sm:gap-2">
                  <span className="text-foreground/70 sm:w-32 shrink-0">Geschäftsführung:</span> 
                  <span className="text-foreground !text-base">T&amp;M Hoch&amp;Tiefbau</span>
                </p>
                <p className="flex flex-col sm:flex-row sm:gap-2">
                  <span className="text-foreground/70 sm:w-32 shrink-0">Registergericht:</span> 
                  <span className="text-foreground !text-base">Amtsgericht Bad Kreuznach</span>
                </p>
                
              </div>
              <div className="space-y-2">
                <p className="flex flex-col sm:flex-row sm:gap-2">
                  <span className="text-foreground/70 sm:w-24 shrink-0">USt-IdNr.:</span> 
                  <span className="text-foreground !text-base">DE 460532058</span>
                </p>
                <p className="flex flex-col sm:flex-row sm:gap-2">
                  <span className="text-foreground/70 sm:w-24 shrink-0">Steuernummer:</span> 
                  <span className="text-foreground !text-base">06/075/32009</span>
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>;
}